import { COMMON_ACTIONS } from "../actions/CommonActions";

let initialState = {
  vehiclesList: [],
};

const commonReducer = (state = initialState, action) => {
  const { type, values } = action;
  switch (type) {
    case COMMON_ACTIONS.SET_VEHICLES:
      return { ...state, vehiclesList: values.vehicles };
    default:
      break;
  }
  return state;
};

export default commonReducer;
